import React from "react";
import * as S from "./styles";

const Main = ({ bgColor, isSubmenu, children, padding }) => {
  return (
    <S.StyleMain bgColor={bgColor} isSubmenu={isSubmenu} padding={padding}>
      {children}
    </S.StyleMain>
  );
};

export default Main;
